var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1429 0H3.85714C1.7269 0 0 1.7269 0 3.85714V14.1429C0 16.2731 1.7269 18 3.85714 18H14.1429C16.2731 18 18 16.2731 18 14.1429V3.85714C18 1.7269 16.2731 0 14.1429 0Z",
    fill: "#E65563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8782 4.62779L13.1145 7.35254C13.1145 7.35254 12.2886 7.35254 11.4626 6.52878C10.6367 5.70502 10.6367 4.88126 10.6367 4.88126L13.4004 2.12482C11.8438 1.74462 9.96956 2.25156 8.82594 3.39215C7.11052 5.10304 8.63534 7.28918 8.1906 7.73274C5.7763 10.2357 3.29847 12.1367 3.23494 12.2318C2.50429 12.9605 2.47253 14.1327 3.1714 14.8298C3.87028 15.5268 5.04566 15.4951 5.7763 14.7664C5.8716 14.6714 7.9047 12.105 10.2872 9.72878C10.732 9.28522 12.8286 10.9011 14.6076 9.15848C15.7194 8.01789 16.2594 6.18027 15.8782 4.62779ZM4.66446 14.1644C4.21972 14.1644 3.87028 13.8159 3.87028 13.3723C3.87028 12.8971 4.21972 12.5486 4.66446 12.5486C5.10919 12.5486 5.45863 12.8971 5.45863 13.3407C5.45863 13.7842 5.10919 14.1644 4.66446 14.1644Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTicket);
export default __webpack_public_path__ + "static/media/serviceTicket.f7663daec11f465ef4d66e4b24508dcd.svg";
export { ForwardRef as ReactComponent };